export const PRODUCTS = {
  TIME_TRACKING: 'timeTracking',
  TIME_TRACKING_REPORTS: 'timeTrackingReports',
};
